import MyProfile from './MyProfile'
import MyGenerators from './pages/MyGenerators/MyGenerators'
import MyAllOperations from './pages/MyAllOperations/MyAllOperations'

export { MyProfile, MyGenerators, MyAllOperations }
